<!-- 登录页面 - OriginGuard 风格 -->
<template>
    <div class="login-container">
        <!-- 全局科技背景层 -->
        <div class="bg-layer">
            <!-- 基础渐变 -->
            <div class="gradient gradient-1"></div>
            <div class="gradient gradient-2"></div>
            
            <!-- 科技网格 -->
            <div class="tech-grid"></div>

            <!-- 穿梭流光 -->
            <div class="light-flows">
                <div class="light-beam beam-1"></div>
                <div class="light-beam beam-2"></div>
                <div class="light-beam beam-3"></div>
                <div class="light-beam beam-4"></div>
            </div>

            <!-- 辅助装饰 -->
            <div class="corner corner-tl"></div>
            <div class="corner corner-tr"></div>
            <div class="corner corner-bl"></div>
            <div class="corner corner-br"></div>

            <!-- 旋转刻度盘 -->
            <div class="rotating-circle">
                <div class="inner-circle"></div>
            </div>
        </div>

        <!-- 登录卡片 -->
        <div class="login-card">
            <!-- Logo 区域 -->
            <div class="logo-area">
                <div class="logo-icon" :class="modeClass">
                    <svg v-if="currentMode === 'login'" class="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                        <path d="M9 12l2 2 4-4"></path>
                    </svg>
                    <svg v-else-if="currentMode === 'register'" class="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                        <circle cx="8.5" cy="7" r="4"></circle>
                        <line x1="20" y1="8" x2="20" y2="14"></line>
                        <line x1="23" y1="11" x2="17" y2="11"></line>
                    </svg>
                    <svg v-else class="icon-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                </div>
                <h1 class="main-title">
                    {{ currentMode === 'login' ? 'OriginGuard' : currentMode === 'register' ? '加入 OriginGuard' : '找回密码' }}
                </h1>
                <p class="subtitle">
                    <span class="line"></span>
                    {{ currentMode === 'login' ? '万物皆可溯 · 诚信连天下' : currentMode === 'register' ? '开启数字化品牌保护' : '通过手机号快速找回' }}
                    <span class="line"></span>
                </p>
            </div>

            <!-- 表单区域 -->
            <div class="form-container">
                <transition name="fade-slide" mode="out-in">
                    <form @submit.prevent="handleSubmit" :key="currentMode" class="form-area">
                        <!-- 错误提示 -->
                        <div v-if="errorMsg" class="error-box">{{ errorMsg }}</div>

                        <!-- 注册模式 - 姓名输入 -->
                        <div v-if="currentMode === 'register'" class="form-group">
                            <label class="form-label">姓名 / 企业名称</label>
                            <div class="input-wrapper">
                                <div class="input-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z"></path>
                                        <path d="M19 10v2a7 7 0 0 1-14 0v-2"></path>
                                        <line x1="12" y1="19" x2="12" y2="22"></line>
                                    </svg>
                                </div>
                                <input type="text" v-model="formInline.name" placeholder="请输入您的真实姓名" class="form-input" />
                            </div>
                        </div>

                        <!-- 手机号码 -->
                        <div class="form-group">
                            <label class="form-label">手机号码</label>
                            <div class="input-wrapper">
                                <div class="input-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
                                        <line x1="12" y1="18" x2="12.01" y2="18"></line>
                                    </svg>
                                </div>
                                <input type="text" v-model="formInline.phone"  placeholder="请输入您的手机号" class="form-input" />
                            </div>
                        </div>

                        <!-- 验证码 (注册/忘记密码) -->
                        <!-- <div v-if="currentMode === 'register' || currentMode === 'forgot'" class="form-group">
                            <label class="form-label">短信验证码</label>
                            <div class="code-input-wrapper">
                                <div class="input-wrapper code-input">
                                    <input type="text" v-model="formInline.code" maxlength="6" placeholder="6位验证码" class="form-input" @input="filterCode" />
                                </div>
                                <button type="button" @click="getCode" :disabled="isSendingCode" class="code-btn">
                                    {{ isSendingCode ? '发送中...' : '获取验证码' }}
                                </button>
                            </div>
                        </div> -->

                        <!-- 密码 -->
                        <div class="form-group">
                            <div class="label-row">
                                <label class="form-label">{{ currentMode === 'forgot' ? '新密码' : '登录密码' }}</label>
                                <!-- <button v-if="currentMode === 'login'" type="button" @click="switchMode('forgot')" class="forgot-btn">忘记密码？</button> -->
                            </div>
                            <div class="input-wrapper">
                                <div class="input-icon">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                    </svg>
                                </div>
                                <input type="password" v-model="formInline.pwd" :placeholder="currentMode === 'forgot' ? '请设置新密码' : '请输入密码'" class="form-input" />
                            </div>
                        </div>

                        <!-- 提交按钮 -->
                        <button type="submit" class="submit-btn" :class="btnClass">
                            {{ currentMode === 'login' ? '立即登录' : currentMode === 'register' ? '创建账户' : '重置密码' }}
                            <svg class="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <line x1="5" y1="12" x2="19" y2="12"></line>
                                <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                        </button>
                    </form>
                </transition>

                <!-- 底部切换 -->
                <div class="switch-section">
                    <p class="switch-text">
                        {{ currentMode === 'login' ? '还没有账号？' : '想要返回？' }}
                        <button @click="switchMode(currentMode === 'login' ? 'register' : 'login')" class="switch-btn">
                            {{ currentMode === 'login' ? '立即注册' : '返回登录' }}
                        </button>
                    </p>
                </div>
            </div>

            <!-- 品牌标识 -->
            <div class="brand-indicators">
                <div class="indicator">
                    <span class="indicator-text">Security</span>
                    <div class="indicator-bar blue"></div>
                </div>
                <div class="indicator">
                    <span class="indicator-text">Traceability</span>
                    <div class="indicator-bar cyan"></div>
                </div>
                <div class="indicator">
                    <span class="indicator-text">Reliability</span>
                    <div class="indicator-bar green"></div>
                </div>
            </div>
            
            <!-- 系统支持 -->
            <div class="system-support">系统支持 | 商乔科技</div>
        </div>
    </div>
</template>

<script>
import { login, tokens, login_yzm, yzm_login, reg_login } from "@/api/index";
import { windowsRise } from "@/utils/dom";
import { setCookies, getCookies, setStorages } from "@/utils/helper";

export default {
    data() {
        return {
            innerHeight: 0,
            formInline: {
                account: "",
                pwd: "",
                phone: "",
                code: "",
                name: "",
            },
            currentMode: "login", // login | register | forgot
            errorMsg: "",
            isSendingCode: false,
            code_value: 1,
            timer: null,
            time_value: "60",
            status_value: 1,
        };
    },
    computed: {
        modeClass() {
            return {
                "mode-login": this.currentMode === "login",
                "mode-register": this.currentMode === "register",
                "mode-forgot": this.currentMode === "forgot",
            };
        },
        btnClass() {
            return {
                "btn-login": this.currentMode === "login",
                "btn-register": this.currentMode === "register",
                "btn-forgot": this.currentMode === "forgot",
            };
        },
    },
    metaInfo: {
        title: "OriginGuard - 登录",
        meta: [
            {
                name: "viewport",
                content: "width=device-width,user-scalable=yes,initial-scale=1",
            },
        ],
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    mounted() {
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.initAnimations();
        this.checkTokenLogin();
        this.loadSavedAccount();
    },
    created() {
        var _this = this;
        document.onkeydown = function (e) {
            if (_this.$route.name === "登录") {
                let key = e.keyCode;
                if (key === 13) {
                    _this.handleSubmit();
                }
            }
        };
    },
    methods: {
        initAnimations() {
            // 初始化动画效果
        },
        checkTokenLogin() {
            let hashPart = window.location.hash;
            let queryString = hashPart.replace(/^#\/\?/, "?");
            let params = new URLSearchParams(queryString);
            let tokenValue = params.get("token");
            if (tokenValue) {
                tokens({ token: tokenValue })
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.saveUserData(res.data);
                        this.$router.push({ path: "/admin" });
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
  
        filterCode(e) {
            this.formInline.code = e.target.value.replace(/\D/g, "");
        },
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
        },
        validatePhone(num) {
            return /^1[3-9]\d{9}$/.test(num);
        },
        switchMode(mode) {
            this.currentMode = mode;
            this.errorMsg = "";
            this.formInline = {
                account: this.formInline.account,
                pwd: "",
                phone: this.formInline.phone,
                code: "",
                name: "",
            };
        },
        handleSubmit() {
            this.errorMsg = "";
            
          
            if (this.currentMode === "register" || this.currentMode === "forgot")  {
                // 手机号验证
                if (!this.validatePhone(this.formInline.phone)) {
                    this.errorMsg = "请输入正确的11位手机号码";
                    return;
                }

            }
            // 注册模式额外验证
            if (this.currentMode === "register") {
                if (!this.formInline.name || this.formInline.name.trim().length < 2) {
                    this.errorMsg = "请输入真实姓名或企业名称";
                    return;
                }
                  
                if (this.formInline.pwd.length < 6) {
                    this.errorMsg = "密码长度不能少于6位";
                    return;
                }
                // if (this.formInline.code.length !== 6) {
                //     this.errorMsg = "请输入完整的6位验证码";
                //     return;
                // }
            }

            // 忘记密码模式验证
            if (this.currentMode === "forgot") {
                if (this.formInline.pwd.length < 6) {
                    this.errorMsg = "密码长度不能少于6位";
                    return;
                }
                if (this.formInline.code.length !== 6) {
                    this.errorMsg = "请输入完整的6位验证码";
                    return;
                }
            }

            // 登录模式
            if (this.currentMode === "login") {
                console.log("login")
                if (!this.formInline.phone || !this.formInline.pwd) {
                    this.errorMsg = "手机号和密码不能为空";
                    return;
                }
                login({
                    account: this.formInline.phone,
                    pwd: this.formInline.pwd,
                })
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.saveUserData(res.data);
                        this.saveAccount(this.formInline.phone, this.formInline.pwd);
                        this.$router.push({ path: "/admin" });
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.currentMode === "register") {
                console.log("register")
                // 注册接口（使用现有验证码登录接口作为示例）
                reg_login({
                    phone: this.formInline.phone,
                    name: this.formInline.name,
                    pwd: this.formInline.pwd,
                    // code: this.formInline.code,
                })
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.saveUserData(res.data);
                        this.$router.push({ path: "/admin" });
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            } else if (this.currentMode === "forgot") {
                console.log("forgot")
                // 忘记密码接口
                yzm_login({
                    phone: this.formInline.phone,
                    code: this.formInline.code,
                })
                    .then((res) => {
                        this.$Message.success("密码重置成功！请使用新密码登录");
                        this.switchMode("login");
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
            }
        },
        getCode() {
            if (!this.validatePhone(this.formInline.phone)) {
                this.errorMsg = "请先输入正确的手机号";
                return;
            }
            this.isSendingCode = true;
            login_yzm({ phone: this.formInline.phone })
                .then((res) => {
                    this.$Message.success(res.msg || "验证码已发送");
                    this.isSendingCode = false;
                    this.startCountdown();
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                    this.isSendingCode = false;
                });
        },
        startCountdown() {
            this.code_value = 2;
            setTimeout(() => {
                this.code_value = 3;
            }, 1000);
            this.time_value = 60;
            this.timer = setInterval(() => {
                if (this.time_value > 1) {
                    this.time_value--;
                } else {
                    clearInterval(this.timer);
                    this.code_value = 4;
                }
            }, 1000);
        },
        saveUserData(data) {
            setCookies("p_c_access_token", data.token);
            setStorages("infos", data);
            localStorage.setItem("user", data.account || data.phone);
            localStorage.setItem("phone", data.phone);
            localStorage.setItem("id", data.id);
            localStorage.setItem("admin_id", data.admin_id);
            localStorage.setItem("demo_file_path", data.demo_file_path);
            localStorage.setItem("SUYUANPCQRCODELENGTH", data.qrcode_length);
            localStorage.setItem("SUYUANPCPID", data.pid);
            if (data.tips_path) {
                localStorage.setItem("tips_path", data.tips_path);
                localStorage.setItem("tips_link", data.tips_link);
            }
            this.$store.commit("setMenus", data.menu);
            localStorage.setItem("IDENTITYS", data.identitys);
            localStorage.setItem("app_ids", data.app_ids);
        },
        loadSavedAccount() {
            const savedPhone = getCookies("saved_phone");
            const savedPwd = getCookies("saved_pwd");
            if (savedPhone) {
                this.formInline.phone = savedPhone;
            }
            if (savedPwd) {
                this.formInline.pwd = savedPwd;
            }
        },
        saveAccount(phone, pwd) {
            setCookies("saved_phone", phone, 30);
            setCookies("saved_pwd", pwd, 30);
        },
    },
};
</script>

<style scoped>
/* 容器 */
.login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    overflow: hidden;
    font-family: system-ui, -apple-system, sans-serif;
}

/* 背景层 */
.bg-layer {
    position: fixed;
    inset: 0;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

/* 渐变 */
.gradient {
    position: absolute;
    border-radius: 50%;
    filter: blur(120px);
    opacity: 0.4;
}

.gradient-1 {
    width: 50%;
    height: 50%;
    top: -25%;
    left: -25%;
    background: #dbeafe;
}

.gradient-2 {
    width: 50%;
    height: 50%;
    bottom: -25%;
    right: -25%;
    background: #cffafe;
}

/* 科技网格 */
.tech-grid {
    position: absolute;
    inset: 0;
    opacity: 0.1;
    background-image: 
        linear-gradient(to right, #3b82f6 1px, transparent 1px),
        linear-gradient(to bottom, #3b82f6 1px, transparent 1px);
    background-size: 60px 60px;
}

/* 流光效果 */
.light-flows {
    position: absolute;
    inset: 0;
    overflow: hidden;
}

.light-beam {
    position: absolute;
    width: 400px;
    height: 3px;
    filter: blur(1px);
}

.beam-1 {
    top: -10%;
    left: -10%;
    background: linear-gradient(to right, transparent, #3b82f6, transparent);
    transform: rotate(45deg);
    box-shadow: 0 0 20px #3b82f6;
    animation: beamMove1 4s linear infinite;
}

.beam-2 {
    top: -10%;
    right: -10%;
    background: linear-gradient(to right, transparent, #06b6d4, transparent);
    transform: rotate(-45deg);
    box-shadow: 0 0 20px #06b6d4;
    animation: beamMove2 5s linear infinite;
    animation-delay: 1.5s;
}

.beam-3 {
    bottom: -10%;
    left: -10%;
    background: linear-gradient(to right, transparent, #60a5fa, transparent);
    transform: rotate(-45deg);
    box-shadow: 0 0 20px #60a5fa;
    animation: beamMove3 6s linear infinite;
    animation-delay: 3s;
}

.beam-4 {
    bottom: -10%;
    right: -10%;
    background: linear-gradient(to right, transparent, #22d3ee, transparent);
    transform: rotate(45deg);
    box-shadow: 0 0 20px #22d3ee;
    animation: beamMove4 7s linear infinite;
    animation-delay: 4.5s;
}

@keyframes beamMove1 {
    0% { transform: rotate(45deg) translateX(-100%); opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { transform: rotate(45deg) translateX(150%); opacity: 0; }
}

@keyframes beamMove2 {
    0% { transform: rotate(-45deg) translateX(100%); opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { transform: rotate(-45deg) translateX(-150%); opacity: 0; }
}

@keyframes beamMove3 {
    0% { transform: rotate(-45deg) translateX(-100%); opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { transform: rotate(-45deg) translateX(150%); opacity: 0; }
}

@keyframes beamMove4 {
    0% { transform: rotate(45deg) translateX(100%); opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { transform: rotate(45deg) translateX(-150%); opacity: 0; }
}

/* 角落装饰 */
.corner {
    position: absolute;
    width: 80px;
    height: 80px;
    border: 4px solid rgba(59, 130, 246, 0.1);
}

.corner-tl {
    top: 40px;
    left: 40px;
    border-top: none;
    border-left: none;
    border-top-left-radius: 20px;
}

.corner-tr {
    top: 40px;
    right: 40px;
    border-top: none;
    border-right: none;
    border-top-right-radius: 20px;
}

.corner-bl {
    bottom: 40px;
    left: 40px;
    border-bottom: none;
    border-left: none;
    border-bottom-left-radius: 20px;
}

.corner-br {
    bottom: 40px;
    right: 40px;
    border-bottom: none;
    border-right: none;
    border-bottom-right-radius: 20px;
}

/* 旋转圆环 */
.rotating-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1400px;
    height: 1400px;
    transform: translate(-50%, -50%);
    border: 1px solid rgba(59, 130, 246, 0.05);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: rotate 120s linear infinite;
    opacity: 0.5;
}

.inner-circle {
    width: 1350px;
    height: 1350px;
    border: 1px dashed rgba(59, 130, 246, 0.1);
    border-radius: 50%;
}

@keyframes rotate {
    from { transform: translate(-50%, -50%) rotate(0deg); }
    to { transform: translate(-50%, -50%) rotate(360deg); }
}

/* 登录卡片 */
.login-card {
    position: relative;
    z-index: 10;
    width: 100%;
    max-width: 520px;
    padding: 40px;
}

/* Logo 区域 */
.logo-area {
    text-align: center;
    margin-bottom: 45px;
}

.logo-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    border-radius: 20px;
    background: white;
    border: 1px solid #dbeafe;
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.1);
    margin-bottom: 16px;
    transition: all 0.3s ease;
}

.logo-icon.mode-login .icon-svg {
    color: #2563eb;
}

.logo-icon.mode-register .icon-svg {
    color: #0891b2;
}

.logo-icon.mode-forgot .icon-svg {
    color: #d97706;
}

.icon-svg {
    width: 40px;
    height: 40px;
}

.main-title {
    font-size: 36px;
    font-weight: 900;
    color: #0f172a;
    margin: 0 0 8px 0;
    letter-spacing: -0.5px;
}

.subtitle {
    color: #64748b;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.line {
    width: 32px;
    height: 1px;
    background: #e2e8f0;
}

/* 表单容器 */
.form-container {
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
    border-radius: 24px;
    border: 1px solid white;
    padding: 32px;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
}

.form-area {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* 错误提示 */
.error-box {
    background: #fef2f2;
    border: 1px solid #fee2e2;
    color: #dc2626;
    font-size: 12px;
    font-weight: 700;
    padding: 10px 16px;
    border-radius: 12px;
}

/* 表单组 */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: 12px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-left: 4px;
}

.label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.forgot-btn {
    font-size: 12px;
    color: #2563eb;
    font-weight: 700;
    background: none;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s;
}

.forgot-btn:hover {
    opacity: 0.7;
}

/* 输入框包装 */
.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
    pointer-events: none;
    color: #cbd5e1;
    transition: color 0.2s;
}

.input-icon svg {
    width: 20px;
    height: 20px;
}

.input-wrapper:focus-within .input-icon {
    color: #2563eb;
}

.form-input {
    width: 100%;
    padding: 14px 16px 14px 44px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    transition: all 0.2s;
}

.form-input::placeholder {
    color: #94a3b8;
    font-weight: 500;
}

.form-input:focus {
    outline: none;
    border-color: rgba(37, 99, 235, 0.5);
    background: white;
    box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
}

/* 验证码输入 */
.code-input-wrapper {
    display: flex;
    gap: 12px;
}

.code-input {
    flex: 1;
}

/* 验证码按钮 */
.code-btn {
    padding: 0 16px;
    background: #f1f5f9;
    color: #475569;
    font-size: 12px;
    font-weight: 700;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.code-btn:hover:not(:disabled) {
    background: #e2e8f0;
}

.code-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* 提交按钮 */
.submit-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    border: none;
    border-radius: 16px;
    color: white;
    font-size: 14px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.submit-btn:active {
    transform: scale(0.98);
}

.submit-btn.btn-login {
    background: #2563eb;
}

.submit-btn.btn-login:hover {
    background: #1d4ed8;
    box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
}

.submit-btn.btn-register {
    background: #0891b2;
}

.submit-btn.btn-register:hover {
    background: #0e7490;
    box-shadow: 0 8px 20px rgba(8, 145, 178, 0.3);
}

.submit-btn.btn-forgot {
    background: #d97706;
}

.submit-btn.btn-forgot:hover {
    background: #b45309;
    box-shadow: 0 8px 20px rgba(217, 119, 6, 0.3);
}

.arrow-icon {
    width: 20px;
    height: 20px;
    margin-left: 8px;
    transition: transform 0.2s;
}

.submit-btn:hover .arrow-icon {
    transform: translateX(4px);
}

/* 切换区域 */
.switch-section {
    margin-top: 32px;
    padding-top: 24px;
    border-top: 1px solid #f1f5f9;
    text-align: center;
}

.switch-text {
    color: #64748b;
    font-size: 14px;
    font-weight: 600;
}

.switch-btn {
    color: #2563eb;
    font-weight: 800;
    background: none;
    border: none;
    cursor: pointer;
    margin-left: 4px;
    transition: opacity 0.2s;
}

.switch-btn:hover {
    opacity: 0.8;
}

/* 品牌标识 */
.brand-indicators {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    gap: 32px;
}

.indicator {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.indicator-text {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: 800;
    color: #94a3b8;
}

.indicator-bar {
    width: 32px;
    height: 4px;
    border-radius: 9999px;
}

.indicator-bar.blue {
    background: rgba(191, 219, 254, 0.5);
}

.indicator-bar.cyan {
    background: rgba(165, 243, 252, 0.5);
}

.indicator-bar.green {
    background: rgba(209, 250, 229, 0.5);
}

/* 系统支持 */
.system-support {
    text-align: center;
    font-size: 12px;
    font-weight: 500;
    color: #94a3b8;
    margin-top: 24px;
}

/* 过渡动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.3s ease;
}

.fade-slide-enter {
    opacity: 0;
    transform: translateX(20px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}
</style>
